var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1635 6.57545C18.1635 7.44195 17.4545 8.15091 16.588 8.15091C16.4521 8.15303 16.3166 8.13444 16.1863 8.09577L13.382 10.8922C13.4214 11.0182 13.4371 11.16 13.4371 11.3018C13.4371 12.1683 12.7282 12.8773 11.8617 12.8773C10.9952 12.8773 10.2862 12.1683 10.2862 11.3018C10.2862 11.16 10.302 11.0182 10.3414 10.8922L8.33266 8.8835C8.20662 8.92288 8.06483 8.93864 7.92304 8.93864C7.78125 8.93864 7.63946 8.92288 7.51342 8.8835L3.92926 12.4755C3.96865 12.6016 3.98441 12.7355 3.98441 12.8773C3.98441 13.7438 3.27545 14.4527 2.40895 14.4527C1.54245 14.4527 0.833496 13.7438 0.833496 12.8773C0.833496 12.0108 1.54245 11.3018 2.40895 11.3018C2.55074 11.3018 2.68466 11.3176 2.81069 11.357L6.40273 7.7728C6.36334 7.64676 6.34759 7.50497 6.34759 7.36318C6.34759 6.49668 7.05654 5.78773 7.92304 5.78773C8.78954 5.78773 9.4985 6.49668 9.4985 7.36318C9.4985 7.50497 9.48274 7.64676 9.44336 7.7728L11.4521 9.7815C11.5781 9.74212 11.7199 9.72636 11.8617 9.72636C12.0035 9.72636 12.1453 9.74212 12.2713 9.7815L15.0677 6.9772C15.0291 6.84686 15.0105 6.71139 15.0126 6.57545C15.0126 5.70895 15.7215 5 16.588 5C17.4545 5 18.1635 5.70895 18.1635 6.57545Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTimeline);
export default __webpack_public_path__ + "static/media/ic-timeline.e18d582aaa06fcbdb481350e8c8a72c7.svg";
export { ForwardRef as ReactComponent };